import { render, staticRenderFns } from "./NoticeMain.vue?vue&type=template&id=6aeb174c&"
import script from "./NoticeMain.vue?vue&type=script&lang=js&"
export * from "./NoticeMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports